<template>
    <div>
        <div class="c-tr gap-1 flex-wrap">
            <div class="c-td">
                <p class="mb-0">
                    <strong v-text="product.name" />
                </p>
                <span v-if="product.ean" v-text="`EAN: ${product.ean}`" />
            </div>

            <!-- Promo price col -->
            <div v-if="userCanEdit && product.main" class="c-td">
                <span
                    v-text="'Cena zestawu'"
                    class="typo-label d-block d-md-none"
                />
                <money-input
                    class="mb-0"
                    :key="`p-${product.id}`"
                    :price="product.price"
                    :max-value="+product.max_price"
                    :disabled="false"
                    :invalid="!!invalidFeedbackPrice"
                    :invalid-feedback="invalidFeedbackPrice"
                    @onInput="changeProductPrice(product, $event)"
                />
            </div>
            <div
                v-else-if="promoType === PROMO_TYPES.BONDED_PRECENTAGE && product.main"
                class="c-td"
            >
                <span class="typo-label d-block d-md-none">
                    Rabat %
                    <span class="nowrap">do zestawu</span>
                </span>
                {{ product.price }}%
            </div>
            <div class="c-td" v-else-if="product.main">
                <span
                    v-text="'Cena zestawu'"
                    class="typo-label d-block d-md-none"
                />

                {{ product.price | currency(promoType) }}
            </div>

            <slot name="showMoreBtn" />
        </div>
        <slot />
    </div>
</template>

<script>
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    props: {
        // product is a set in this context
        product: {
            type: Object,
            required: true
        },
        merchantId: {
            type: Number,
            required: false
        },
        promotion: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            PROMO_TYPES
        }
    },

    computed: {
        isPromoEditPermission() {
            return this.$store.getters.isPromoEditPermission
        },
        isEditablePromo() {
            return this.$store.getters.isEditablePromo(this.promoType)
        },
        userCanEdit() {
            return this.isEditablePromo && this.isPromoEditPermission
        },
        promoType() {
            return this.promotion.type
        },
        subscription() {
            return this.promotion.subscriptions.find(
                sub => sub.merchant_id === this.merchantId
            ) || {}
        },
        invalidFeedbackPrice() {
            return +this.product.price > +this.product.max_price
                ? `Wartość maksymalna: ${this.$options.filters.currency(
                    this.product.max_price
                )}`
                : undefined
        }
    },
    methods: {
        changeProductPrice(product, price) {
            this.subscription.product_set_subscriptions.forEach(p => {
                if (p.id === product.id) {
                    p.price = price
                }
            })
        }
    }
}
</script>
